/**
 * Lightweight user-action telemetry (Sentry messages in production).
 */

import * as Sentry from '@sentry/react'

export function trackUserAction(action: string, data?: Record<string, unknown>): void {
  if (!import.meta.env.PROD || !import.meta.env.VITE_SENTRY_DSN) {
    if (import.meta.env.DEV) {
      console.debug('[telemetry]', action, data)
    }
    return
  }

  Sentry.captureMessage(`user_action:${action}`, {
    level: 'info',
    tags: { category: 'user_action', action },
    extra: data,
  })
}

/** Product / observability signals (bell, surfaces), distinct from explicit user_action clicks. */
export function trackObservability(signal: string, data?: Record<string, unknown>): void {
  if (!import.meta.env.PROD || !import.meta.env.VITE_SENTRY_DSN) {
    if (import.meta.env.DEV) {
      console.debug('[observability]', signal, data)
    }
    return
  }

  Sentry.captureMessage(`observability:${signal}`, {
    level: 'warning',
    tags: { category: 'observability', signal },
    extra: data,
  })
}
